var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.148,
    height: 17.441,
    viewBox: "0 0 24.148 17.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16935",
    "data-name": "Group 16935",
    transform: "translate(-280.944 -391.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M26,5.535,2,5.6Zm-.411,16.441H2.449V6.064l10.7,8.245a1.484,1.484,0,0,0,1.736,0L25.512,6.4Z",
    transform: "translate(278.995 386.496)",
    fill: "none",
    stroke: "#1d1d1f",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalEmail);
export default __webpack_public_path__ + "static/media/personalEmail.7b2abda01fd14a8d1be5d1cc8472de2c.svg";
export { ForwardRef as ReactComponent };